import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

const _hasLtBracket = /</;
const _hasGtBracket = />/;
@Directive({
  selector: '[forbidAngleBrackets]',
})
export class ForbidAngleBracketsDirective {
  private tooltip = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;

    const message = this.getTooltipMessage(input?.value);
    if (message) {
      this.showTooltip(message);
    } else {
      this.hideTooltip(); //happy path
    }
  }

  private getTooltipMessage = (currentText: string) => {
    if (!currentText?.length) {
      //must be a string with length
      return null;
    }
    if (_hasLtBracket.test(currentText)) {
      if (_hasGtBracket.test(currentText)) {
        return `'<' and '>' characters are not allowed`;
      }
      return `'<' character is not allowed`;
    }
    if (_hasGtBracket.test(currentText)) {
      return `'>' character is not allowed`;
    }
    return null;
  };

  private showTooltip(message: string) {
    if (!this.tooltip) {
      this.tooltip = this.buildToolTip();
    }
    console.error(message);
    (this.tooltip as any).innerText = message;
  }

  private buildToolTip = () => {
    const tooltipSpan = this.renderer.createElement('span');
    this.renderer.addClass(tooltipSpan, 'bracket-error');
    this.renderer.appendChild(this.el.nativeElement.parentElement, tooltipSpan);
    return tooltipSpan;
  };

  private hideTooltip() {
    if (this.tooltip) {
      this.renderer.removeChild(this.el.nativeElement.parentElement, this.tooltip);
      this.tooltip = null;
    }
  }
}
